<template>
<div class="chapter">
<div class="inner_page">
<div id="uetgOraGNQWpQ7X767i3lh2">
<p class="ORIM-Chapter-Title-Page-Break--Body-" id="u7fVqKC7kv4B5Oz3O3DmZGD"></p>
<p class="center"><em class="italic">The past is never dead. It’s not even past.</em></p>
<p class="center"><em class="italic">—William Faulkner</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlmostDark4.vue?4fdcc92f